import { takeEvery, put, call } from 'redux-saga/effects';
import * as actions from '../actions/rcmAssignment';
import * as API from '../api/rcmAssignment';
import { sessionErrorHandling } from './session';

function* list() {
    try {
        yield put({ type: actions.RCM_ASSIGNMENT_LANDING_PENDING });
        const payload = yield call(API.getRCMAssignmentList);
        yield put({ type: actions.RCM_ASSIGNMENT_LANDING_FULFILLED, payload });
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.RCM_ASSIGNMENT_LANDING_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* changePrecedence(action) {
    try {
        yield put({ type: actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE_PENDING });
        const { options, callback } = action.payload;
        const payload = yield call(API.setPrecedence, options);
        yield put({ type: actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE_FULFILLED, payload });
        if (callback) {
            callback();
        }
    } catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}



export default function* () {
    yield takeEvery(actions.RCM_ASSIGNMENT_LANDING, list);
    yield takeEvery(actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE, changePrecedence);

}